import Axios from "axios";
import helperMethods from "./helpers/helperMethods";
import store from "./store";

Axios.interceptors.response.use(
  response => {
    // Do something with response data
    return response;
  },
  error => {
    // Handle 401 Unauthorized errors (expired tokens)
    if (error.response && error.response.status === 401) {
      // Clear authentication state
      store.dispatch("logout");
      // Redirect to login page
      window.location.href = "/login";
      return Promise.reject(error);
    }

    helperMethods.setSnackBarErrorFromErrorResponse(error);
    return Promise.reject(error);
  }
);

Axios.interceptors.request.use(
  response => {
    // Do something with response data
    // console.log(response.headers);
    return response;
  },
  error => {
    helperMethods.setSnackBarErrorFromErrorResponse(error);
    return Promise.reject(error);
  }
);
